"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharingActions = exports.getSharingIcons = exports.getItemTypeIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _maps = _interopRequireDefault(require("./itemTypeIcons/maps16.svg"));
var _features = _interopRequireDefault(require("./itemTypeIcons/features16.svg"));
var _mapimages = _interopRequireDefault(require("./itemTypeIcons/mapimages16.svg"));
var _imagery = _interopRequireDefault(require("./itemTypeIcons/imagery16.svg"));
var _table = _interopRequireDefault(require("./itemTypeIcons/table16.svg"));
var _maptiles = _interopRequireDefault(require("./itemTypeIcons/maptiles16.svg"));
var _datafilesgray = _interopRequireDefault(require("./itemTypeIcons/datafilesgray16.svg"));
var _datafiles = _interopRequireDefault(require("./itemTypeIcons/datafiles16.svg"));
var _apps = _interopRequireDefault(require("./itemTypeIcons/apps16.svg"));
var _feed = _interopRequireDefault(require("./itemTypeIcons/feed16.svg"));
var _storymap = _interopRequireDefault(require("./itemTypeIcons/storymap16.svg"));
var _streamlayer = _interopRequireDefault(require("./itemTypeIcons/streamlayer16.svg"));
var _dashboard = _interopRequireDefault(require("./itemTypeIcons/dashboard16.svg"));
var _vectortile = _interopRequireDefault(require("./itemTypeIcons/vectortile16.svg"));
var _vectortilepackage = _interopRequireDefault(require("./itemTypeIcons/vectortilepackage16.svg"));
var _bigdataanalytics = _interopRequireDefault(require("./itemTypeIcons/bigdataanalytics16.svg"));
var _realtimeanalytics = _interopRequireDefault(require("./itemTypeIcons/realtimeanalytics16.svg"));
var _websceneglobal = _interopRequireDefault(require("./itemTypeIcons/websceneglobal16.svg"));
var _sceneweblayerpoint = _interopRequireDefault(require("./itemTypeIcons/sceneweblayerpoint16.svg"));
var _style = _interopRequireDefault(require("./itemTypeIcons/style16.svg"));
var _notebook = _interopRequireDefault(require("./itemTypeIcons/notebook16.svg"));
var _hubsite = _interopRequireDefault(require("./itemTypeIcons/hubsite16.svg"));
var _hubinitiative = _interopRequireDefault(require("./itemTypeIcons/hubinitiative16.svg"));
var _hubpage = _interopRequireDefault(require("./itemTypeIcons/hubpage16.svg"));
var _experiencebuilder = _interopRequireDefault(require("./itemTypeIcons/experiencebuilder16.svg"));
var _webexperiencetemplate = _interopRequireDefault(require("./itemTypeIcons/webexperiencetemplate16.svg"));
var _reportTemplate = _interopRequireDefault(require("./itemTypeIcons/report-template16.svg"));
var _storymaptheme = _interopRequireDefault(require("./itemTypeIcons/storymaptheme16.svg"));
var _statisticaldatacollection = _interopRequireDefault(require("./itemTypeIcons/statisticaldatacollection16.svg"));
var _workbook = _interopRequireDefault(require("./itemTypeIcons/workbook16.svg"));
var _insightspage = _interopRequireDefault(require("./itemTypeIcons/insightspage16.svg"));
var _insightsmodel = _interopRequireDefault(require("./itemTypeIcons/insightsmodel16.svg"));
var _kml = _interopRequireDefault(require("./itemTypeIcons/kml16.svg"));
var _solutions = _interopRequireDefault(require("./itemTypeIcons/solutions16.svg"));
var _tilepackage = _interopRequireDefault(require("./itemTypeIcons/tilepackage16.svg"));
var _layersgray = _interopRequireDefault(require("./itemTypeIcons/layersgray16.svg"));
var _imagecollection = _interopRequireDefault(require("./itemTypeIcons/imagecollection16.svg"));
var _scenepackage = _interopRequireDefault(require("./itemTypeIcons/scenepackage16.svg"));
var _quickcaptureproject = _interopRequireDefault(require("./itemTypeIcons/quickcaptureproject16.svg"));
var _mobilescenepackage = _interopRequireDefault(require("./itemTypeIcons/mobilescenepackage16.svg"));
var _QuestionIcon = _interopRequireDefault(require("calcite-ui-icons-react/QuestionIcon"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // Item Type Icons
// Fallback Item Type Icon
var props = {
  scale: "s",
  style: {
    display: "flex"
  }
};
var sharingActions = [{
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "globe"
  }, props)),
  label: "Sharing level: Everyone (public)",
  onClick: function onClick(item) {
    return console.log(item);
  },
  id: "public"
}, {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "user"
  }, props)),
  label: "Sharing level: Owner",
  onClick: function onClick(item) {
    return console.log(item);
  },
  id: "private"
}, {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "group"
  }, props)),
  label: "Group",
  onClick: function onClick(item) {
    return console.log(item);
  },
  id: "group"
}, {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "organization"
  }, props)),
  label: "Sharing level: Organization",
  onClick: function onClick(item) {
    return console.log(item);
  },
  id: "org"
}, {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "user"
  }, props)),
  label: "Sharing level: Owner",
  onClick: function onClick(item) {
    return console.log(item);
  },
  id: "shared"
}];
exports.sharingActions = sharingActions;
var getItemTypeIcon = function getItemTypeIcon(rowData) {
  var _rowData$typeKeywords, _rowData$typeKeywords2;
  var imgStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var iconSrc;
  var iconAlt;
  switch (rowData.type) {
    case "Web Map":
    case "Code Attachment":
    case "Workforce Project":
    case "Native Application":
    case "CityEngine Web Scene":
    case "Oriented Imagery Catalog":
      iconSrc = _maps.default;
      break;
    case "Map Service":
    case "WMS":
      iconSrc = _mapimages.default;

      // Map Service Type Keywords
      if ((_rowData$typeKeywords = rowData.typeKeywords) === null || _rowData$typeKeywords === void 0 ? void 0 : _rowData$typeKeywords.includes("Tiled")) {
        iconSrc = _maptiles.default;
        iconAlt = "Tiled Map Service";
      }
      break;
    case "Feature Service":
    case "Feature Collection":
    case "WFS":
      iconSrc = _features.default;

      // Feature Service Type Keywords
      if ((_rowData$typeKeywords2 = rowData.typeKeywords) === null || _rowData$typeKeywords2 === void 0 ? void 0 : _rowData$typeKeywords2.includes("Table")) {
        iconSrc = _table.default;
        iconAlt = "Table";
      }
      break;
    case "Image Service":
      iconSrc = _imagery.default;
      break;
    case "Table":
      iconSrc = _table.default;
      break;
    case "Tile Layers":
      iconSrc = _maptiles.default;
      iconAlt = "Tiled Map Service";
      break;
    case "WMTS":
      iconSrc = _maptiles.default;
      iconAlt = "WMTS";
      break;
    case "CSV Collection":
    case "Code Sample":
    case "Microsoft Excel":
    case "Form":
    case "Image":
    case "PDF":
    case "File Geodatabase":
    case "Microsoft Word":
    case "SQLite Geodatabase":
    case "Desktop Application Template":
    case "Document Link":
      iconSrc = _datafilesgray.default;
      break;
    case "CSV":
    case "Shapefile":
    case "Service Definition":
    case "GeoJson":
      iconSrc = _datafiles.default;
      break;
    case "Desktop Application":
    case "Mobile Application":
    case "Web Mapping Application":
    case "Operation View":
    case "Application":
      iconSrc = _apps.default;
      break;
    case "Feed":
      iconSrc = _feed.default;
      break;
    case "StoryMap":
      iconSrc = _storymap.default;
      break;
    case "Stream Service":
      iconSrc = _streamlayer.default;
      break;
    case "Dashboard":
      iconSrc = _dashboard.default;
      break;
    case "Vector Tile Service":
      iconSrc = _vectortile.default;
      break;
    case "Vector Tile Package":
      iconSrc = _vectortilepackage.default;
      break;
    case "Big Data Analytic":
      iconSrc = _bigdataanalytics.default;
      break;
    case "Real Time Analytic":
      iconSrc = _realtimeanalytics.default;
      break;
    case "Web Scene":
      iconSrc = _websceneglobal.default;
      break;
    case "Scene Service":
      iconSrc = _sceneweblayerpoint.default;
      break;
    case "Style":
      iconSrc = _style.default;
      break;
    case "Notebook":
      iconSrc = _notebook.default;
      break;
    case "Hub Site Application":
      iconSrc = _hubsite.default;
      break;
    case "Hub Initiative":
      iconSrc = _hubinitiative.default;
      break;
    case "Hub Page":
      iconSrc = _hubpage.default;
      break;
    case "Web Experience":
      iconSrc = _experiencebuilder.default;
      break;
    case "Web Experience Template":
      iconSrc = _webexperiencetemplate.default;
      break;
    case "Report Template":
      iconSrc = _reportTemplate.default;
      break;
    case "StoryMap Theme":
      iconSrc = _storymaptheme.default;
      break;
    case "Statistical Data Collection":
      iconSrc = _statisticaldatacollection.default;
      break;
    case "Insights Workbook":
      iconSrc = _workbook.default;
      break;
    case "Insights Model":
      iconSrc = _insightsmodel.default;
      break;
    case "Insights Page":
      iconSrc = _insightspage.default;
      break;
    case "Project Package":
    case "Map Package":
    case "Mobile Map Package":
      iconSrc = _maps.default;
      break;
    case "KML":
      iconSrc = _kml.default;
      break;
    case "Solution":
      iconSrc = _solutions.default;
      break;
    case "Tile Package":
    case "Compact Tile Package":
      iconSrc = _tilepackage.default;
      break;
    case "Layer Package":
      iconSrc = _layersgray.default;
      break;
    case "Image Collection":
      iconSrc = _imagecollection.default;
      break;
    case "Scene Package":
      iconSrc = _scenepackage.default;
      break;
    case "QuickCapture Project":
      iconSrc = _quickcaptureproject.default;
      break;
    case "Mobile Scene Package":
      iconSrc = _mobilescenepackage.default;
      break;
    default:
      // Fallback Icon
      return /*#__PURE__*/_react.default.createElement(_QuestionIcon.default, {
        size: 16,
        alt: "Item Type Fallback Icon",
        style: imgStyle,
        key: "question"
      });
  }
  return /*#__PURE__*/_react.default.createElement("img", {
    key: iconSrc,
    src: iconSrc,
    width: "16",
    height: "16",
    alt: iconAlt || rowData.type,
    title: iconAlt || rowData.type,
    style: imgStyle
  });
};
exports.getItemTypeIcon = getItemTypeIcon;
var getSharingIcons = function getSharingIcons(_ref) {
  var item = _ref.item;
  var matchingSharingIcon = null;
  var groupAction = null;
  var filteredSharingIcons = [];
  if (item && (item === null || item === void 0 ? void 0 : item.access)) {
    matchingSharingIcon = sharingActions.find(function (action) {
      return action.id === (item === null || item === void 0 ? void 0 : item.access);
    });
  }
  if (matchingSharingIcon) {
    filteredSharingIcons = [].concat(_toConsumableArray(filteredSharingIcons), [matchingSharingIcon]);
    if (item === null || item === void 0 ? void 0 : item.accessInformation) {
      groupAction = sharingActions.find(function (action) {
        return action.id === "group";
      });
    }
    if (groupAction && (item === null || item === void 0 ? void 0 : item.access) === "private") {
      filteredSharingIcons = [].concat(_toConsumableArray(filteredSharingIcons), [groupAction]);
    }
  }
  return filteredSharingIcons;
};
exports.getSharingIcons = getSharingIcons;